import { getAuthToken } from '../utils/authUtils'; //

class ProviderService {
  constructor() {
    this.baseURL = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
    this.apiPath = '/clinical';
  }

  async getAuthHeaders() {
    const token = await getAuthToken();
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  // Get providers by facility and role
  async getProvidersByFacility(facilityId, role = 'doctor') {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${this.baseURL}${this.apiPath}/facilities/${facilityId}/providers?role=${role}`, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Failed to get providers: ${response.statusText}`);
      }

      const result = await response.json();
      return result.providers || [];
    } catch (error) {
      console.error('Error getting providers:', error);
      throw error;
    }
  }
}

// Create a singleton instance
const providerService = new ProviderService();

// Named exports for commonly used methods
export const getProvidersByFacility = providerService.getProvidersByFacility.bind(providerService);

export default providerService;
